<template>
  <div v-if="pending" class="nxp-pending-container w-full flex flex-col md:flex-row">
    <div class="nxp-pending-text">
      <h3>Você ainda não se candidatou</h3>
      <p>
        Sua candidatura para <b>{{ title }}</b> ainda não foi enviada para a
        empresa.
      </p>
    </div>
    <button class="nxp-pending-button" :style="{ backgroundColor: color }" @click="goToQuickApply">
      Quero me candidatar
    </button>
  </div>
</template>

<script>
import {
  fetchPublicVacancy,
  fetchExistingApplication,
} from "@/services/application";
import { trackEvent } from "@/services/posthog";

// Quem chega pelo link de uma vaga e sai da confirmacao sem se candidatar
// ("Agora nao", "Cancelar") cai aqui com o vacancy_id na URL. Sem este aviso
// o primeiro chamado da tela e o banner do Recrutest, e o candidato fazia o
// teste achando que era a candidatura (caso Avvio, vaga 157284). O aviso fica
// ACIMA do Recrutest e nunca o esconde: o DISC continua aparecendo para todos
// como antes.
export default {
  name: "PendingApplicationBanner",
  data: () => ({
    pending: false,
    title: "",
    color: "#1551b1",
  }),
  computed: {
    companyLabel() {
      return this.$route.params.company_label;
    },
    vacancyId() {
      return this.$route.params.vacancy_id;
    },
  },
  created() {
    this.check();
  },
  methods: {
    async check() {
      // Vaga anonima usa uuid e tem fluxo proprio.
      if (!this.vacancyId || this.companyLabel === "anonima") {
        this.setPending(false);
        return;
      }

      try {
        const [{ company, vacancy }, existing] = await Promise.all([
          fetchPublicVacancy(this.companyLabel, this.vacancyId),
          fetchExistingApplication(this.vacancyId),
        ]);

        // Vaga fechada ou de outra empresa volta sem vacancy.
        if (!vacancy || !vacancy.id || existing.exists) {
          this.setPending(false);
          return;
        }

        this.title = vacancy.name || "esta vaga";
        this.color = company.base_hexcolor || this.color;
        this.setPending(true);
        trackEvent("pending_application_banner_shown", {
          vacancy_id: vacancy.id,
          company_label: this.companyLabel,
        });
      } catch (_) {
        this.setPending(false);
      }
    },
    setPending(value) {
      this.pending = value;
    },
    goToQuickApply() {
      trackEvent("pending_application_banner_clicked", {
        vacancy_id: this.vacancyId,
        company_label: this.companyLabel,
      });
      this.$router.push({
        name: "quick-apply",
        params: {
          company_label: this.companyLabel,
          vacancy_id: this.vacancyId,
        },
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.nxp-pending-container {
  align-items: center;
  gap: 16px 24px;
  padding: 24px;
  border-radius: 16px;
  background: #ECEBEB;
}

.nxp-pending-text {
  display: flex;
  flex-direction: column;
  gap: 8px;

  h3 {
    color: #333;
    font-family: Roboto;
    font-size: 20px;
    font-weight: 600;
  }

  p {
    color: #696969;
    font-family: Roboto;
    font-size: 16px;
    font-weight: 400;
  }

  p b {
    color: #4F4F4F;
    font-weight: 600;
  }
}

.nxp-pending-button {
  display: flex;
  height: 48px;
  padding: 8px 32px;
  justify-content: center;
  align-items: center;
  flex-shrink: 0;
  border-radius: 8px;
  color: #FFF;
  font-family: Roboto;
  font-size: 16px;
  font-weight: 600;
  border: none;
  cursor: pointer;
  transition: all ease 0.3s;

  @media (min-width: 768px) {
    margin-left: auto;
  }

  @media (max-width: 767px) {
    width: 100%;
  }
}

.nxp-pending-button:hover {
  filter: brightness(0.9);
}
</style>
